// Create a client.
const configPaypal = function(onbuttonRenderedCallback) {
	if ('undefined' !== typeof braintree) {
		// The PayPal button will be rendered in an html element with the ID
		// `paypal-button`. This callback function will be called when the PayPal button
		// is set up and ready to be used
		onbuttonRenderedCallback = onbuttonRenderedCallback || function() {};

		braintree.client.create({
			authorization: brainTreeAuthorizationToken
		}).then(function(clientInstance) {
			// Create a PayPal Checkout component.
			return braintree.paypalCheckout.create({
				client: clientInstance
			});
		}).then(function(paypalCheckoutInstance) {
			return paypalCheckoutInstance.loadPayPalSDK({
				currency: 'USD',
				intent: 'authorize'
			});
		}).then(function(paypalCheckoutInstance) {
			paypal.Buttons({
				fundingSource: paypal.FUNDING.PAYPAL,
				style: {
					// horizontal | vertical
					layout: isFromCheckout ? 'vertical' : 'horizontal',
					// medium | large | responsive
					size:   'responsive',
					// pill | rect
					shape:  'pill',
					label:  'paypal',
					// gold | blue | silver | black
					color:  isFromCheckout ? 'white' : 'blue',
					tagline: 'false',
					height: 40
				},

				createOrder: function() {
					if (isFromCheckout) {
						ga('send', 'event', 'Checkout', 'Summary', 'Express Checkout button: PayPal');
					} else if (isFromProduct) {
						let productId = $('#productIDValue').val();
						ga('send', 'event', 'Item', 'Product - ' + productId + ' Form', 'Buy Now with Paypal', productId);
					} else {
						ga('send', 'event', 'Cart', 'Summary', 'Checkout button: PayPal');
					}
					return paypalCheckoutInstance.createPayment({
						flow: 'checkout',
						amount: $('.checkout-price').data('price') != undefined
							? parseFloat($('.checkout-price').data('price'))
							: parseFloat($('.summaryHead .subtotal').text().replace(/\$/g, '')),
						currency: 'USD',
						intent: 'authorize',
						no_shipping: '2',
						enableShippingAddress: true,
						shippingAddressEditable: true
					});
				},

				onShippingChange: function(data, actions) {
					paymentToken = data.paymentToken;

					oldShippingAddress = data.shipping_address;
					return getSonicShippingMethod(data)
						.then((res) => {
							var subtotal =  $('.checkout-price').data('price') != undefined
								? parseFloat($('.checkout-price').data('price'))
								: parseFloat($('.summaryHead .subtotal').text().replace(/\$/g, ''));
							var sonicShippingMethods = res.sonicShippingOptions;
							var shippingCost = sonicShippingMethods[0].amount.value;
							var taxAmount = res.taxAmount;

							// update shipping cost and selected shipping method if user selects any
							if (data.selected_shipping_option != null) {
								let selectedShippingObjIndex = sonicShippingMethods.findIndex((obj => obj.id == data.selected_shipping_option.id));
								if (selectedShippingObjIndex > -1) {
									for (var i in sonicShippingMethods) {
										if (sonicShippingMethods[i].id == data.selected_shipping_option.id) {
											sonicShippingMethods[i].selected = true;
											shippingCost = sonicShippingMethods[i].amount.value
										} else {
											sonicShippingMethods[i].selected = false;
										}
									}
								}
							}
							return actions.order.patch([
								{
									op: 'replace',
									path: '/purchase_units/@reference_id==\'default\'/amount',
									value: {
										currency_code: 'USD',
										value: (parseFloat(subtotal) + parseFloat(shippingCost) + parseFloat(taxAmount)).toFixed(2),
										breakdown: {
											item_total: {
												currency_code: 'USD',
												value: subtotal
											},
											shipping: {
												currency_code: 'USD',
												value: shippingCost
											},
											tax_total: {
												currency_code:'USD',
												value:taxAmount
											}
										}
									}
								},
								{
									op: data.selected_shipping_option != null ? "replace" : "add",
									path: "/purchase_units/@reference_id=='default'/shipping/options",
									value: sonicShippingMethods
								}
							]);
						})
						.catch((err) => {
							return actions.reject();
						});
				},

				onApprove: function(data, actions) {
					$('#savingModal').modal('show');
					$(".buyNowContainer").removeClass("active");
					return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
						processPayment(payload)
							.then((res) => {
								$('#savingModal').modal('hide');
								window.location.href = res.redirect;
							})
							.catch((err) => {
								$('#savingModal').modal('hide');
								window.location.reload();
							});
					});
				},

				onCancel: function(data) {

				},

				onError: function(err) {
					logError(err);
				}
			}).render('#paypal-button-buy-now');
		}).then(onbuttonRenderedCallback);
	}
};

let paymentToken = '',
	oldShippingAddress = null;

// returns shipping options to use in paypal
const generateShippingOptionsForPaypal = function(shippingMethod) {
	// clears previously set shipping option's cost
	let sonicShippingOptions = [];
	shippingMethod.forEach(method => {
		let methodObj = {
			id: method.code,
			type: 'SHIPPING',
			label: method.label,
			selected: false,
			amount: {
				value: (method.fee).toString(),
				currency_code: 'USD'
			}
		};
		sonicShippingOptions.push(methodObj);
	});

	if (sonicShippingOptions.length > 0) {
		sonicShippingOptions[0].selected = true;
	}
	return sonicShippingOptions;
};

// returns all available shipping method for given zip, address, country
const getSonicShippingMethod = function(data) {
	let postData = {
			'country': data.shipping_address.country_code,
			'zip': data.shipping_address.postal_code,
			'address': data.shipping_address.city
		};
	let productId = $('#productIDValue').val(),
		selectedExtendedWarrantyId = $('#selected-extended-warranty-id').val();

	if (productId) {
		postData['productId'] = productId;
	}

	if(selectedExtendedWarrantyId) {
		postData['extendedWarrantyId'] = selectedExtendedWarrantyId;
	}

	return new Promise((resolve, reject) => {
		$.ajax({
			dataType: 'json',
			type: 'POST',
			url: '/checkout/express/get-shipping-details',
			data: postData,
			error: function (err) {
				reject();
			},
			success: function (data) {
				if (data.success && data.shippingMethod.length > 0) {
					// shipping methods
					let shippingMethods = Object.values(JSON.parse(data.shippingMethod));
					if (shippingMethods.length > 0) {
						let response = {
							sonicShippingOptions: generateShippingOptionsForPaypal(shippingMethods),
							taxAmount: data.taxValue
						};
						resolve(response);
					} else {
						reject();
					}
				} else {
					// can't find shipping method for given address
					reject();
				}
			}
		});
	});
};

// process the payment and complete order
const processPayment = function(payload) {
	return new Promise((resolve, reject) => {
		$.ajax({
			dataType: 'json',
			type: 'POST',
			url: '/checkout/express/update-paypal-order',
			data: {
				'shippingAddress': payload.details.shippingAddress,
				'email': payload.details.email,
				'phone': payload.details.phone,
				'nonce': payload.nonce,
				'shippingMethod': payload.shippingOptionId,
				'token': paymentToken,
				'payerId': payload.details.payerId
			},
			error: function(err) {
				reject(err);
			},
			success: function(data) {
				if (data.hasOwnProperty('success') && !data.success) {
					if (data.hasOwnProperty('errors')) {
						reject(data.errors);
					} else if (data.hasOwnProperty('alertMessage')) {
						reject(data.alertMessage);
					}
				}
				resolve(data);
			}
		});
	});
};

const logError = function(errorMessage) {
	let errorMsg = errorMessage.toString();
	errorMsg += '\\nurl: ' + window.location.href;
	errorMsg += ('undefined' === typeof errorMessage.stack ? '' : '\\nstack: ' + errorMessage.stack);
	if (window.hasOwnProperty('navigator')) {
		if (typeof window.navigator.userAgent !== 'undefined') {
			errorMsg += '\\nuser agent: ' + window.navigator.userAgent;
		}
	}
	let formData = new FormData();
	formData.append('error', errorMsg);
	fetch('/javascript/error', {
		method: 'POST',
		body: formData
	});
};

export default configPaypal;
